import {
    GET_COMMISSION_LOG,
    UPDATE_COMMISSION_LOG,
  } from "../actions/types";
  
  const initialState = {
    commissionLogList: [],
    commissionLogUpdateStatus: null,
  };
  
  export default function commissionLogReducer(state = initialState, action) {
    switch (action.type) {
      case GET_COMMISSION_LOG:
        return {
          ...state,
          commissionLogList: action.payload.data || [],
        };
      case UPDATE_COMMISSION_LOG:
        return {
          ...state,
          commissionLogUpdateStatus: action.payload.success,
        };
      default:
        return state;
    }
  }